/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { QuicksandBold } from 'components/Text';

export const Container = styled.div`
    display:flex;
    flex-direction:column;
    margin-bottom: 15px;
`;
export const PlaceHolder = styled.label`
    font-size: 16px;
    color: ${Colors.GRAY[1]};
    width: auto;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 8px 8px 0;
`;
export const InputTags = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: 42px;
    width: 480px;
    padding: 0 8px;
    border: 1px solid rgb(214, 216, 218);
    border-radius: 8px;
    &:focus-within {
        border: 1px solid #0052cc;
    }
`;

export const TagInput = styled.input`
    flex: 1;
    display:none;
    border: none;
    width:100%;
    height: 42px;
    font-size: 14px;
    padding: 4px 0 0 0;
    &:focus {
        outline: transparent;
    }
`;

export const Tags = styled.ul`
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 8px 0 0 0;
    justify-content: space-between;
    align-items: center;
    justify-items:center;
    height:48px;
`;

export const Tag = styled.li`
    cursor: 'pointer';
    width: auto;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    padding: 0 8px;
    font-size: 14px;
    list-style: none;
    border-radius: 6px;
    margin: 0 8px 8px 0;
    background: ${Colors.GREEN};
`;
export const TagTitle = styled.span`
    margin-top: 3px;
    font-weight:bold;
    color:${Colors.GRAY[6]};
    cursor: 'pointer';
`;
export const DocumentType = styled.text`
    font-weight: 600;
    color:${Colors.GRAY[6]};
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${Colors.GRAY[3]};
`;
